import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const RootHeader = styled.div`
  flex-shrink: 0;
`;

export const RootBody = styled.div`
  ${(props) => props.theme.breakpoint.Md} {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    align-items: stretch;
    background-color: var(--c-mainnav-bg);
  }

  ${(props) => props.theme.breakpoint.LtMd} {
    isolation: isolate;
  }
`;

interface RootNavProps {
  $isOpenMobile?: boolean;
}

export const RootNav = styled.nav<RootNavProps>`
  ${(props) => props.theme.breakpoint.LtLg} {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 100%;
    width: 100%;
    transition: transform 200ms ease;
    z-index: ${(props) => props.theme.zindex.mainNavigation};

    ${({ $isOpenMobile }) =>
      $isOpenMobile &&
      css`
        transform: translateX(100%);
      `}
  }
`;

export const RootMain = styled.main`
  padding: var(--main-gutter);
  scroll-padding-top: var(--main-gutter); // Offset scroll to anchor links
  background-color: var(--c-bg-main);

  ${(props) => props.theme.breakpoint.Md} {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: auto;
    border-top-left-radius: ${size(3)};
  }

  // Make sure it is placed above the border extension from MainNavigation
  ${(props) => props.theme.breakpoint.Lg} {
    z-index: 1;
  }
`;

// Element used to center Loader for full page loading state
export const RootLoaderCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
